import { Modal } from 'antd';
import dayjs from 'dayjs';
import { generateUUID } from 'utils/uuid';

import APIClient from '../restAPI';
import getBuildDate from './getBuildDate';

let timeoutId: ReturnType<typeof setTimeout> | undefined;
const timeoutDelay = 1000 * 60 * 3;

export default function startCheckingForNewBuild(): void {
  if (timeoutId === undefined) {
    timeoutId = setTimeout(checkForNewBuild, timeoutDelay);
  }
}

function checkForNewBuild(): void {
  APIClient.get('/?' + generateUUID()).then(parseData, (e: unknown) =>
    console.log(e),
  );
}

function parseData(response: { data: string }): void {
  const { data } = response;

  const customDom = document.createElement('html');
  customDom.innerHTML = data;

  const newBuildDate = dayjs(new Date(getBuildDate(customDom)));
  const currentBuildDate = dayjs(new Date(getBuildDate(document)));

  if (newBuildDate.isAfter(currentBuildDate)) {
    const modal = Modal.confirm({
      title: 'A new version is available, Refresh is recommended.',
      okText: 'Refresh',
      cancelText: 'Cancel',
      onOk: () => window.location.reload(),
      onCancel: () => modal.destroy(),
    });
  } else {
    timeoutId = setTimeout(checkForNewBuild, timeoutDelay);
  }
}
